export default __webpack_public_path__ + "static/media/soehne-mono-leicht.b5e8a910.woff";